<template>
  <div class="task-overview-component">
    <lazy-component v-on:intersected="intersected" v-bind:is-intersected="forceIntersect">
<!--      <div class="panel-body">-->
      <div class="container-sm flex-row gap-md align-items-center justify-content-between">
        <laravel-pagination
            v-if="hasTasks && displayPagination"
            v-bind:data="currentRequestData"
            @pagination-change-page="loadTasksPage"
            style="margin: 0;vertical-align: middle; margin-top: -4px; margin-right: 1.5rem;"
        ></laravel-pagination>

        <template v-if="hasTasks">Per pagina</template>
        <a-select v-if="hasTasks" :default-value="perPage" @change="handlePerPageChange">
          <a-select-option :value="15">
            15
          </a-select-option>
          <a-select-option :value="25">
            25
          </a-select-option>
          <a-select-option :value="50">
            50
          </a-select-option>
          <a-select-option :value="100">
            100
          </a-select-option>
        </a-select>

        <!--                TODO: NEEDS TO HAVE THE ProductCategory Type to get all productCategories by Type -->
        <global-product-labels-select
            :productCategory="ProductCategoryEnum.TASK"
            style="
              display: flex;
              flex: 1;
              gap: 16px;
              align-items: center;
            "
        ></global-product-labels-select>
        <!--                <global-product-labels-select></global-product-labels-select>-->

        <div v-if="hasTasks" class="flex-stretch flex-row justify-content-end">
          <a-popconfirm
              v-if="displayActiveTasks"
              placement="topRight"
              title="Weet je zeker dat je deze taken wil afronden?"
              ok-text="Afronden"
              cancel-text="Annuleren"
              :disabled="!hasSelection"
              @confirm="onCompleteAllClick"
          >
            <a-button type="primary" :disabled="!hasSelection">
              <check-icon style="margin-right: 0.3em;"></check-icon>
              {{ selectedTasks.length > 0 ? selectedTasks.length + ' afronden' : 'Afronden' }}
            </a-button>
          </a-popconfirm>
          <a-popconfirm
              v-if="!displayActiveTasks"
              placement="topRight"
              title="Weet je zeker dat je deze taken weer wil activeren?"
              ok-text="Activeren"
              cancel-text="Annuleren"
              :disabled="!hasSelection"
              @confirm="onActivateAllClick"
          >
            <a-button type="primary" :disabled="!hasSelection">
              <check-icon></check-icon>
              {{ this.selectedTasks.length > 0 ? this.selectedTasks.length + ' activeren' : 'Activeren' }}
            </a-button>
          </a-popconfirm>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table v-if="hasTasks" class="table">
          <thead>
          <tr>
            <th class="compact half-padding">
              <a-checkbox ref="globalCheckbox" :checked="allSelected" :indeterminate="indeterminate"
                          @change="onSelectAllChanged"></a-checkbox>
            </th>
            <th class="compact">Omschrijving</th>
            <th class="compact">Labels</th>
            <th class="compact">Gekoppeld aan</th>
            <th class="compact">Klant</th>
            <th class="compact">Datum</th>
            <th class="compact">Gemaakt door</th>
            <th v-if="!displayActiveTasks" class="compact">Afgerond door</th>
            <th v-if="!displayActiveTasks" class="compact">Afgerond op</th>
            <th v-if="displayActiveTasks" class="compact">Toegewezen aan</th>
            <th class="compact" colspan="2"></th>
          </tr>
          </thead>
          <tbody v-bind:class="{ loading: loading }">
          <tr v-if="!initialized">
            <td :colspan="displayActiveTasks ? 8 : 9">Laden ...</td>
          </tr>
          <TaskRowComponent
              v-for="task in tasks"
              :key="task.id"
              :task="task"
              :interval="interval"
              :user-id="userId"
              :displayProductLabels="true"
              @onSelectionChanged="onSelectionChanged"
              @onCompleted="onCompleted"
              @onUnmatched="onUnmatched"
              @onDateChanged="onDateChanged"
              @onDeleted="onDeleted"
          >
          </TaskRowComponent>
          </tbody>
        </table>
      </div>
      <div v-if="hasTasks" class="panel-body" style="padding-top: 0;">
        <laravel-pagination
            v-if="displayPagination"
            :data="currentRequestData"
            @pagination-change-page="loadTasksPage"
            style="margin: 0;"
        ></laravel-pagination>
      </div>
    </lazy-component>
    <div v-if="hasTasks === false" class="widget-body" style="margin: 1.5rem;">
      <p>Er zijn geen {{ displayActiveTasks ? 'onafgehandelde' : 'afgeronde' }} taken.</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ProductCategoryEnum } from '~/enums'
import taskApi from '~/api/task'
import store from '../../../store'
import taskModule from '../store'
import TaskRowComponent from './TaskRowComponent'

export default {
  name: 'TaskOverviewComponent',
  props: {
    departmentId: {
      type: Number,
      default: null
    },
    userId: {
      type: Number,
      required: true
    },
    interval: {
      type: Number,
      default: 1
    },
    page: {
      type: Number,
      default: 1
    },
  },
  components: {
    TaskRowComponent
  },
  data () {
    return {
      currentPage: null,
      tasks: [],
      currentRequestData: {},
      allSelected: false,
      loading: true,
      initialized: false,
      ProductCategoryEnum: ProductCategoryEnum,
    }
  },
  created () {
    if (!store.hasModule('task')) {
      store.registerModule('task', taskModule)
    }
  },
  computed: {
    ...mapGetters([
      'forceIntersect'
    ]),
    ...mapGetters('task', [
      'name',
      'selectedTasks',
      'perPage',
      'labelIds'
    ]),
    indeterminate () {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.tasks.length
          && this.currentSelectionDiff > 0
    },
    currentSelectionDiff () {
      return this.tasks.filter(i => this.selectedTasks.findIndex(x => x.id === i.id) < 0).length
    },
    displayPagination () {
      return typeof this.currentRequestData.meta !== 'undefined'
    },
    hasSelection () {
      return this.selectedTasks.length > 0
    },
    selectedUnlinkableTasks () {
      return this.selectedTasks.filter(task => typeof task.customer !== 'undefined' && task.customer !== null)
    },
    hasUnlinkableSelection () {
      return this.selectedUnlinkableTasks.length > 0
    },
    displayActiveTasks () {
      return this.interval >= 0
    },
    hasTasks () {
      return (this.initialized && this.tasks.length > 0) || !this.initialized
    }
  },
  methods: {
    ...mapActions('task', [
      'setPerPage',
    ]),
    onSelectionChanged (task, selected, shiftKey) {
      if (selected === true) {
        this.selectTask(task)
      } else {
        this.deselectTask(task)
      }
    },
    onSelectAllChanged () {
      this.allSelected = !this.allSelected

      for (let i in this.tasks) {
        let task = this.tasks[i]

        if (this.allSelected === true && this.selectedTasks.findIndex(x => x.id === task.id) < 0) {
          this.selectTask(task)
        } else if (this.allSelected === false) {
          this.deselectTask(task)
        }
      }
    },
    selectTask (task) {
      store.dispatch('task/selectTask', task)
      if (this.currentSelectionDiff === 0) {
        this.allSelected = true
      }
    },
    deselectTask (task) {
      this.allSelected = false
      store.dispatch('task/deselectTask', task)
    },
    deselectAllTasks () {
      this.allSelected = false
      store.dispatch('task/deselectAllTasks')
    },
    loadTasksPage (page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return
      }
      this.loading = true

      if (this.departmentId !== null) {
        if (this.displayActiveTasks) {
          taskApi.getActiveByDepartmentId(this.departmentId, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        } else {
          taskApi.getCompletedByDepartmentId(this.departmentId, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        }
      } else {
        if (this.displayActiveTasks) {
          taskApi.getActiveByUserId(this.userId, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        } else {
          taskApi.getCompletedByUserId(this.userId, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        }
      }
    },
    reloadTasksPage (labelIds) {
      let page = 1
      this.loading = true

      if (this.departmentId !== null) {
        if (this.displayActiveTasks) {
          taskApi.getActiveByDepartmentAndProductLabels(this.departmentId, labelIds, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        } else {
          taskApi.getCompletedByDepartmentAndProductLabels(this.departmentId, labelIds, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        }
      } else {
        if (this.displayActiveTasks) {
          taskApi.getActiveByUserAndProductLabels(this.userId, labelIds, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        } else {
          taskApi.getCompletedByUserAndProductLabels(this.userId, labelIds, this.interval, page, this.perPage).then((tasks) => {
            this.allSelected = false
            this.tasks = tasks.data
            this.currentRequestData = tasks
            this.loading = false
            this.initialized = true
            this.currentPage = page
          }).catch(() => {
            this.$notification['error']({
              message: 'Er ging iets mis',
              description: 'Het is niet gelukt om taken te laden',
            })
          })
        }
      }
    },
    onUnmatchAllClick () {
      this.loading = true

      taskApi.unmatchTasks(this._.map(this.selectedTasks, 'id')).then(() => {
        this.loading = false
        // trigger reload
        for (let i in this.selectedTasks) {
          this.selectedTasks[i].customer = null
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet ontkoppelen',
        })
      })
    },
    onCompleteAllClick () {
      this.loading = true
      taskApi.completeTasks(this._.map(this.selectedTasks, 'id'), this.userId, this.interval).then(response => {
        // trigger reload
        this.loadTasksPage(this.page, true)
        this.deselectAllTasks()

        // TODO remove when push notifications are set up for this count
        response.meta.departmentTasksCounts.forEach((departmentTasksCount) => {
          this.processBadges(
              '.badge.department-task-count[data-id="' + departmentTasksCount.department_hashid + '"]',
              this.displayActiveTasks ? departmentTasksCount.activeCount : departmentTasksCount.completedCount,
          )
        })
        response.meta.userTasksCounts.forEach((userTasksCounts) => {
          this.processBadges(
              '.badge.user-task-count[data-id="' + userTasksCounts.user_hashid + '"]',
              this.displayActiveTasks ? userTasksCounts.activeCount : userTasksCounts.completedCount,
          )
        })

      }).catch(error => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet verwerken',
        })
      })
    },
    onActivateAllClick () {
      this.loading = true
      taskApi.activateTasks(this._.map(this.selectedTasks, 'id'), this.userId, this.interval).then(response => {
        // trigger reload
        this.loadTasksPage(this.page, true)
        this.deselectAllTasks()

        // TODO remove when push notifications are set up for this count
        response.meta.departmentTasksCounts.forEach((departmentTasksCount) => {
          this.processBadges(
              '.badge.department-task-count[data-id="' + departmentTasksCount.department_hashid + '"]',
              this.displayActiveTasks ? departmentTasksCount.activeCount : departmentTasksCount.completedCount,
          )
        })
        response.meta.userTasksCounts.forEach((userTasksCounts) => {
          this.processBadges(
              '.badge.user-task-count[data-id="' + userTasksCounts.user_hashid + '"]',
              this.displayActiveTasks ? userTasksCounts.activeCount : userTasksCounts.completedCount,
          )
        })

      }).catch(error => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet activeren',
        })
      })
    },
    processBadges (badge, count) {
      let $badge = $(badge)
      if (count === 0) {
        $badge.addClass('hidden')
      } else {
        $badge.removeClass('hidden').text(count)
      }
    },
    onCompleted () {
      this.loadTasksPage(this.currentPage, true)
    },
    onUnmatched () {
      // this.loadTasksPage(this.page);
    },
    onDateChanged () {
      this.loadTasksPage(this.currentPage, true)
    },
    onDeleted () {
      this.loadTasksPage(this.currentPage, true)
    },
    handlePerPageChange (perPage) {
      this.setPerPage(perPage)
      this.loadTasksPage(this.page, true)
    },
    intersected () {
      if (!this.initialized) {
        this.loadTasksPage(this.page)
      }
    }
  },
  watch: {
    labelIds (labelIds) {
      if (this.initialized) {
        if (labelIds.length > 0) {
          this.reloadTasksPage(labelIds)
        } else {
          this.loadTasksPage(1, true)
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
tr th.half-padding {
  padding: 4px;
}

tbody.loading {
  opacity: .5;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}
</style>
